import routerOptions0 from "/usr/src/app/content/n3-promos-79fe22c9-72eb-4213-8913-d43a239162b4/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}